import { DataSource } from "@essenza/core";
import { Vista, useVista } from "@essenza/react";
import { useLocation } from "react-router-dom";
import { ContactForm } from "../view/ContactForm";

function ContactVistaController(c) {
    c.skin = ContactVista;
}

export function ContactVista() {
    const [ctx, control] = useVista(ContactVistaController);
    const state = useLocation().state;
    let job;
    let candidate;
    if(state){
        job = state.job;
        candidate = state.candidate;
    }
    //else 
        //candidate = state;
    //console.log("LESSON STATE ID");
    return (
        <Vista context={ctx} >
            <div className="w100">
                <div className="centered max-width-sm text-center">
                    <h3 className="primary-color py-md">{'Contatta ' + candidate?.tname + ' ' + candidate?.tsurname}</h3>
                    <ContactForm job={job} source={new DataSource(candidate || {})}/>
                </div>
            </div>
        </Vista>
    )
}